import { defineStore } from 'pinia'
import { ref } from 'vue'

//compositon:
export const useAlertStore = defineStore('alert', ()=>{
  const alert = ref<any | null>(null);

  function success(message : any){
    alert.value = { message, type: 'alert-success'}
  }

  function error(message : any) { 
    alert.value = { message, type: 'alert-danger'}
  }

  function loading(message : any) { 
    alert.value = { message, type: 'alert-loading'}
  }

  function clear(ms : number = 0){
    setTimeout(()=>{
      alert.value = null;
    }, ms)
    
  }

  return{
    alert,
    success,
    error,
    loading,
    clear
  }
})



/*

export const useAlertStore = defineStore({
  id: 'alert',
  state: () => ({
    alert: null
  }),
  actions: {
    success(message) {
      this.alert = { message, type: 'alert-success' }
    },
    error(message) {
      this.alert = { message, type: 'alert-danger' }
    },
    loading(message){
      this.alert = { message, type: 'alert-loading' }
    },
    clear() {
      this.alert = null
    }
  }
})
*/